import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
